import { IIsaacLink } from 'shared/interfaces'

export const updateISAACLink = (ISAACArray: IIsaacLink[]) =>
  ISAACArray?.map((item) => ({
    title: item.title,
    url: item.url.includes('http') ? item.url : `https://${item.url}`
  })) || []
